/* Some functionality for the tooltip system. */
import { store } from '@/store'

export default {

    /**
     * Returns the left position of an element, provided the elements' ID.
     * @param id - The identifier of the element to retrieve the position for
     * @returns left pos (px)
     */
    getLeftPos (id) {
        return Math.round(document.getElementById(id)?.getBoundingClientRect()?.left);
    },
    /**
     * Returns the top position of an element, provided the elements' ID.
     * @param id - The identifier of the element to retrieve the position for
     * @param offset - Offset to add, so the window doesnt align directly with the element but is slightly below
     * @returns top pos (px)
     */
    getTopPos (id, offset = 4) {
        return Math.round(document.getElementById(id)?.getBoundingClientRect()?.top + window.scrollY + offset);
    },
    /**
     * Returns the right position of an element, provided the elements' ID.
     * @param id - The identifier of the element to retrieve the position for
     * @returns right pos (px)
     */
    getRightPos (id) {
        return Math.round(window.innerWidth - document.getElementById(id)?.getBoundingClientRect()?.right);
    },
    /**
     * Fires a tooltip event (caught in App.vue, so tooltips can be shown everywhere)
     * The event will cause a tooltip box with the according descriptions (in metadata.json) to appear.
     * @param element_id - The identifier of the element to retrieve the position for
     * @param tooltip_id - The identifier of the tooltip to show (mapped to metadata.json)
     * @param tooltip_title - Header line for the tooltip
     * @returns left pos
     */
    fireTooltipEvent (element_id, tooltip_id, tooltip_title) {
        let ww = window.innerWidth;
        let lp = this.getLeftPos(element_id);
        var cevent;
        if (lp > 0.5 * ww) {
            cevent = new CustomEvent("show-tooltip",
                { detail: { title: tooltip_title, right: this.getRightPos(element_id), top: this.getTopPos(element_id), tooltip_id: tooltip_id}});
        } else {
            cevent = new CustomEvent("show-tooltip",
                { detail: { title: tooltip_title, left: lp, top: this.getTopPos(element_id), tooltip_id: tooltip_id}});
        }
    
        window.dispatchEvent(cevent);
    }

}
